import React, { Component } from "react"
import Typography from "@mui/material/Typography"
import TextField from "@mui/material/TextField"
import Button from "@mui/material/Button"
import { withTranslation } from "react-i18next"
import { withRouter } from "react-router-dom"
import Helmet from "react-helmet"
import logo from "../assets/logo.svg"

export default withTranslation()(
  withRouter(
    class UserWelcome extends Component {
      state = { code: "", name: "" }

      render() {
        const {
          t,
          joinRoom,
          joinRoomLoading,
          joinRoomError,
          setJoinRoomError,
          history,
        } = this.props
        const { code, name } = this.state

        return (
          <>
            <Helmet>
              <title>Lapwing - {t`Enter code`}</title>
            </Helmet>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                position: "fixed",
                top: 0,
                left: 0,
                bottom: 0,
                right: 0,
                backgroundColor: "#E6E2B1",
              }}
            >
              <div
                style={{
                  margin: "auto",
                  maxHeight: "100%",
                  overflow: "auto",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    backgroundColor: "#E6E2B1",
                    textAlign: "center",
                    padding: "32px 0 16px 0",
                  }}
                  className="notSelectable"
                >
                  <img alt="" src={logo} style={{ marginBottom: "48px" }} />
                  <Typography
                    variant="h4"
                    style={{
                      fontSize: "30px",
                      fontWeight: 600,
                      margin: "0 32px 8px 32px",
                      color: "#181818",
                    }}
                  >
                    {t`Welcome to the Lapwing app`}
                  </Typography>
                  <Typography
                    variant="h6"
                    style={{
                      fontWeight: 300,
                      margin: "0 32px",
                      color: "#181818",
                    }}
                  >{t`Enter your info below to get started`}</Typography>
                  <TextField
                    label={t`Room code`}
                    variant="outlined"
                    style={{
                      marginTop: "48px",
                      width: "256px",
                      textTransform: "none",
                    }}
                    helperText={joinRoomError ? t`Code not valid` : " "}
                    onChange={(event) => {
                      this.setState({
                        code: event.target.value,
                      })

                      setJoinRoomError(false)
                    }}
                    onKeyPress={(event) => {
                      if (
                        event.key === "Enter" &&
                        /[0-9]{3}[0-9]{3}/.test(code.replace("-", "")) &&
                        (code.length === 7 || code.length === 6) &&
                        name
                      ) {
                        joinRoom(code.replace("-", ""), name)
                      }
                    }}
                  />
                  <TextField
                    label={t`Name`}
                    variant="outlined"
                    style={{
                      marginTop: "16px",
                      width: "256px",
                      textTransform: "none",
                    }}
                    helperText=" "
                    onChange={(event) => {
                      this.setState({
                        name: event.target.value,
                      })

                      setJoinRoomError(false)
                    }}
                    onKeyPress={(event) => {
                      if (
                        event.key === "Enter" &&
                        /[0-9]{3}[0-9]{3}/.test(code.replace("-", "")) &&
                        (code.length === 7 || code.length === 6) &&
                        name
                      ) {
                        joinRoom(code.replace("-", ""), name)
                      }
                    }}
                  />
                  <Button
                    variant="outlined"
                    style={{
                      marginTop: "16px",
                      width: "256px",
                    }}
                    size="large"
                    disabled={
                      !/[0-9]{3}[0-9]{3}/.test(code.replace("-", "")) ||
                      (code.length !== 7 && code.length !== 6) ||
                      !name ||
                      joinRoomLoading
                    }
                    onClick={() => joinRoom(code.replace("-", ""), name)}
                  >{t`Join room`}</Button>
                  <Button
                    style={{
                      marginTop: "8px",
                      width: "256px",
                    }}
                    size="large"
                    onClick={() => history.push("/admin")}
                  >{t`Go to admin panel`}</Button>
                </div>
              </div>
            </div>
          </>
        )
      }
    }
  )
)
